function switchByWidth(){
    if (window.matchMedia('(max-width: 767px)').matches) {
        //スマホ処理
      $(function() {
  $(".m_fastidiousness-list").slick({
    autoplay: true,
    arrows: false,
    slidesToShow: 1,
  });
  });

    } else if (window.matchMedia('(min-width:768px)').matches) {
        //PC処理
      $(function() {
  $(".m_fastidiousness-list").slick({
    autoplay: true,
    arrows: false,
    slidesToShow: 2,
    dots: true,
  });
  });

      
    }
}

//ロードとリサイズの両方で同じ処理を付与する
window.onload = switchByWidth;
window.onresize = switchByWidth;